import EmployeeOnlyModalContainer from "../../employee-only-containers/EmployeeOnlyModalContainer"
import ActionModal from "../../views/modal/ActionModal"
import React from "react"
import { CircleImage } from "../../views/atoms/images/CircleImage"
import { useHistory } from "react-router-dom"
import { FormattedMessage, useIntl } from "react-intl"
import { Box, Button, Typography } from "@carrotfertility/carotene-core"

// @ts-expect-error TS(7031) FIXME: Binding element 'onClose' implicitly has an 'any' ... Remove this comment to see the full error message
export const UpdateBankInfoModal = ({ onClose, onNavigateToAccountPage }) => {
  const history = useHistory()

  const handleGoToBankDetailsClick = () => {
    onNavigateToAccountPage && onNavigateToAccountPage()
    history.push("/bank-details")
  }
  const intl = useIntl()

  return (
    <EmployeeOnlyModalContainer onClose={onClose}>
      {/* @ts-expect-error TS(2322) FIXME: Type '{ children: Element; onExit: any; titleText:... Remove this comment to see the full error message */}
      <ActionModal onExit={onClose} titleText={intl.formatMessage({ defaultMessage: "Please update your bank info" })}>
        <Box
          sx={(theme) => ({
            inlineSize: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingInline: {
              xs: theme.spacing(theme.tokens.spacing.lg),
              md: theme.spacing(theme.tokens.spacing.md),
              lg: theme.spacing(theme.tokens.spacing.xl)
            }
          })}
        >
          <Box
            sx={(theme) => ({
              inlineSize: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              paddingInline: { xs: 0, md: theme.spacing(theme.tokens.spacing.xs) }
            })}
          >
            <Box
              sx={{
                inlineSize: "100%",
                maxInlineSize: { md: "600px", lg: "968px" }
              }}
            >
              <Box sx={{ maxInlineSize: "32rem" }}>
                <Box
                  sx={(theme) => ({
                    marginBlockStart: {
                      xs: theme.spacing(theme.tokens.spacing.lg),
                      lg: theme.spacing(theme.tokens.spacing.xxl)
                    }
                  })}
                >
                  <CircleImage size={88} padding={14} backgroundColor="porcelain" iconName="icn-dollar-sign-large" />
                </Box>
                <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.lg })}>
                  <Typography variant="h3" component="h2">
                    <FormattedMessage defaultMessage="Please update your bank info" />
                  </Typography>
                </Box>
                <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.xs })}>
                  <Typography>
                    <FormattedMessage defaultMessage="Before you can submit a reimbursement request, please update your bank info so we can direct the funds to the right account." />
                  </Typography>
                </Box>
                <Box
                  component="hr"
                  sx={(theme) => ({
                    inlineSize: "100%",
                    marginBlock: theme.spacing(theme.tokens.spacing.lg),
                    marginInline: "auto",
                    borderColor: "rgba(0, 0, 0, 0.05)"
                  })}
                />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" }
                  }}
                >
                  <Button onClick={handleGoToBankDetailsClick}>
                    <FormattedMessage defaultMessage="Update now" />
                  </Button>
                  <Box
                    sx={(theme) => ({
                      marginInlineEnd: theme.tokens.spacing.md,
                      marginBlockStart: theme.tokens.spacing.md
                    })}
                  />
                  <Button variant="outlined" color="secondary" onClick={onClose}>
                    <FormattedMessage defaultMessage="I'll do this later" />
                  </Button>
                </Box>
                <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.lg })} />
              </Box>
            </Box>
          </Box>
        </Box>
      </ActionModal>
    </EmployeeOnlyModalContainer>
  )
}
